// DelayedMount.jsx
import React, { useEffect, useRef, useState } from "react";

export default function DelayedMount({ active, delay = 3000, minVisibleMs = 0, children }) {
	const [show, setShow] = useState(false);
	const timerRef = useRef(null);
	const shownAtRef = useRef(null);

	useEffect(() => {
		const clear = () => { if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; } };

		if (active) {
			// Programa la aparición tras el delay
			timerRef.current = setTimeout(() => {
				setShow(true);
				shownAtRef.current = Date.now();
				timerRef.current = null;
			}, delay);
		} else {
			// Si está visible, respeta minVisibleMs (si se ha pedido)
			if (show && minVisibleMs > 0 && shownAtRef.current) {
				const elapsed = Date.now() - shownAtRef.current;
				const remaining = Math.max(0, minVisibleMs - elapsed);
				timerRef.current = setTimeout(() => {
					setShow(false);
					shownAtRef.current = null;
					timerRef.current = null;
				}, remaining);
			} else {
				setShow(false);
				shownAtRef.current = null;
			}
		}

		return clear;
	}, [active, delay, minVisibleMs, show]);

	if (!show) return null;
	return children;
}
